import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ConfirmationService } from 'primeng/api';
import { selectProjects } from '../../../../store/selectors/projects.selectors';
import { deleteProject, loadProjects } from '../../../../store/actions/projects.actions';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-projects-table',
  imports: [ ConfirmDialogModule, TableModule, CommonModule, ButtonModule],
  providers: [ConfirmationService],
  templateUrl: './projects-table.component.html',
  styleUrl: './projects-table.component.scss'
})
export class ProjectsTableComponent {
  private store = inject(Store);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService)
  projects = this.store.selectSignal(selectProjects);

  loadProjects = effect(() => {
    this.store.dispatch(loadProjects())

  })

  editProject(project : any) {
    // code here
  }
  deleteProject(project: any, event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Voulez-vous vraiment supprimer ce projet ?',
      header: 'Confirmation',
      icon: 'pi pi-info-circle',
      rejectLabel: 'Annuler',
      rejectButtonProps: {
        label: 'Annuler',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Supprimer',
        severity: 'danger',
      },
      accept: () => {
        this.store.dispatch(deleteProject({ projectId: project }));
      }
    });
  }
}
